<template>
  <div id="app">
        <loading-indicator ref="loadingIndicator" />
        <Head v-show="!isIndependent" ></Head>
          <div class="main_bg">
              <router-view></router-view>
          </div>
          <Foot v-show="showFoot"></Foot>
          <el-backtop v-show="showGoTop"></el-backtop>
  </div>
</template>

<script>
import Head from './components/Head'
import Foot from './components/Foot'
import LoadingIndicator from "./components/LoadingIndicator";
import {eventBus} from "./main";

export default {
  name: 'App',
  components: {
      LoadingIndicator,
    Head, Foot
  },
    data() {
      return {
          isIndependent: false,
          showFoot: true,
          showHead: true,
          showGoTop: true,
      }
    },
    created() {
      this.routeChange(this.$route)
    },
    watch: {
        // 如果路由有变化，会再次执行该方法
        '$route': 'routeChange'
    },
    methods: {
        routeChange (e) {
            this.isIndependent = e.path === "/paper_search" || e.path === '/scholar' || e.path === '/wescholar' || e.path === '/citations'
            this.showFoot = !this.isIndependent;
            this.showGoTop = !this.isIndependent || e.path === "/paper_search" || e.path === '/citations'
        }
    }
}
</script>


<style>
html, body {padding: 0; margin: 0 auto; font:normal normal normal 14px/150% microsoft yahei;}
div, dl, dt, dd, ul, ol, li, p, h1, h2, h3, h4, h5, h6, th, td, hr, blockquote, form, header { margin:0 auto; padding:0;}
/*h1, h2, h3, h4, h5, h6, em { font-weight: normal; font-size: 100%; font-style: normal;}*/
.main-style a { cursor: pointer; text-decoration: none; transition:all 0.3s; color: #000000;}
.main-style a:hover { color: #333; text-decoration: none}
.main-style a:active, a:focus { outline: none;}
ul, li { list-style: none;}
img { border: 0;}
input,textarea,fieldset { padding:0px; margin:0 auto}
::-webkit-scrollbar { width: 10px; height: 10px}
::-webkit-scrollbar-button:vertical { display: none}
::-webkit-scrollbar-track:vertical { background-color: #000}
::-webkit-scrollbar-track-piece { background-color: #eee}
::-webkit-scrollbar-thumb:vertical { margin-right: 10px; background-color: #bbb}
::-webkit-scrollbar-thumb:vertical:hover { background-color: #666}
::-webkit-scrollbar-corner:vertical { background-color: #535353}
::-webkit-scrollbar-resizer:vertical { background-color: #FF6E00}
.clearbox { clear: both;}
.f_l { float:left}
.f_r { float:right}

.nav {
    width: 100%;
    height: 45px;
    background: #14aab9;
}

.exchange-top-area-select .el-icon-arrow-up:before {
    content: "\e78f";
}
.el-backtop {
    background-color: #c9c9c9;
}
.el-backtop, .el-calendar-table td.is-today{
    color: red;
}
.justify-inner-label label, .justify-inner-label .el-descriptions-item__label {
    text-align: justify;
    height: 40px;
    overflow: hidden;
}

.justify-inner-label label:after, .justify-inner-label .el-descriptions-item__label:after {
    content: "";
    display: inline-block; padding-left: 100%;
}

.el-tree .el-tree-node__label {
    /*font-weight: bold;*/
}
.el-tree .el-tree-node {
    color: #000000;
}

.el-tree .el-tree-node:focus>.el-tree-node__content {
    background-color: #14aab9b3;
    color: white;
}

.el-tree .el-tree-node__content:hover, .el-upload-list__item:hover {
    background-color: #14aab9b3;
    color: white;
}

.el-tree .is-leaf+span::before {
    html: '<i class="el-icon-menu"></i>';
}

.order-confirmation .el-message-box__status.el-icon-info {
    display: none;
}

.el-button--primary {
    background-color: #14aab9;
    border-color: #0b8f9d;
}

.el-button--primary:focus, .el-button--primary:hover {
    background: #14aab9;
    border-color: #14aab9;
    color: #FFF;
}

.el-button:focus:not(.el-button--text), .el-button:hover:not(.el-button--text) {
    color: #0fa1af;
    border-color: #1cbdd2;
    background-color: #ecf5ff;
    /*color: #0fa1af;*/
    /*background-color: #14aab9;*/
    /*border-color: #0b8f9d;*/
}

.el-radio.is-bordered.is-checked {
    border-color: #14aab9;
}

.el-button--text {
    color: #14aab9;
}

.el-button--text:focus, .el-button--text:hover {
    color: #1cc3d5;
}

.el-radio__input.is-checked+.el-radio__label {
    color: #1cc3d5;
}

.el-radio__inner:hover {
    border-color: #14aab9;
}

.el-radio__input.is-checked .el-radio__inner {
    background-color: #14aab9;
    border-color: #0b8f9d;
}

.el-input.is-active .el-input__inner, .el-input__inner:focus {
    border-color: #0b8f9d;
}

.el-tag {
    background-color: #14aab929;
    border-color: #1db6c5;
    color: #5d969b;
}

.el-tag .el-tag__close {
    color: #9fd8dd;
}
.el-tag .el-tag__close:hover {
    background-color: #1db6c5;
}

.main_bg { width: 100%; min-width: 1200px; /* padding-top: 30px; */}
/*#app {*/
/*  background: url(./assets/bg.png) no-repeat center top;*/
/*}*/

.el-divider--horizontal.top-divider {
    width: 285px;
    height: 2px;
    margin-top: 10px;
}
.el-divider--horizontal.protocol-top-divider {
    width: 205px;
    height: 2px;
    margin-top: 22px;
    position: absolute;
    right: 10px;
    top: 26px;
}
.el-divider--horizontal.exchange-top-divider {
    width: 205px;
    height: 2px;
    margin-top: 22px;
}
.el-divider--horizontal.m0-divider {
    margin: 0;
}

.el-popover:has(.popover) {
    min-width: 10px;
    background-color: rgb(241, 241, 241);
}
.el-popover:has(.popover) .popper__arrow {
    display: none;
}

@font-face {
    font-family: "阿里妈妈数黑体 Bold";font-weight: 700;src: url("//at.alicdn.com/wf/webfont/Gri5PKQloSIz/s6pWaXwzagepiKg947IXc.woff2") format("woff2"),
url("//at.alicdn.com/wf/webfont/Gri5PKQloSIz/5CjmFZ3RIMWMKhi4fldiR.woff") format("woff");
    font-display: swap;
}

@font-face {
    font-family: "阿里巴巴普惠体 2.0 45 Light";font-weight: 300;src: url("//at.alicdn.com/wf/webfont/Gri5PKQloSIz/ADE_ne917L6cVIVlmVPGT.woff2") format("woff2"),
url("//at.alicdn.com/wf/webfont/Gri5PKQloSIz/P9YYWoDp8ULh-6JerwhR_.woff") format("woff");
    font-display: swap;
}

/* .main-style * {
    font-family: times, serif;
} */
.main-style * {
    font-family: HarmonyOS;
}

.el-tooltip__popper.is-dark {
    background-color: #93959b;
}

.el-popover {
    min-width: 0;
}

.article-date-picker * {
    color: black;
}
.article-date-picker input::placeholder {
    color: black;
}

.el-breadcrumb__item:last-child .el-breadcrumb__inner, .el-breadcrumb__item:last-child .el-breadcrumb__inner a, .el-breadcrumb__item:last-child .el-breadcrumb__inner a:hover, .el-breadcrumb__item:last-child .el-breadcrumb__inner:hover {
    color: black;
    font-weight: bolder;
}
</style>



// WEBPACK FOOTER //
// src/App.vue